import axios from 'axios';
import { saveUserAction } from './saveUserAction';

export const uploadProfileImage = (formData) => {

  axios.post(`${import.meta.env.VITE_APP_API_URL}upload-profile-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  })
    .then((response) => {
      saveUserAction({ id_accion: 4, detalles_accion: `Imagen de perfil subida con éxito` });

      return response.data;
    })
    .catch((error) => {
      saveUserAction({ id_accion: 4, detalles_accion: `Error al subir la imagen` });

      console.error('Error al subir la imagen:', error);
      
    });
};